/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum EmployeeType {
  Contractor = "Contractor",
  FixedTermEligible = "Fixed Term (Eligible)",
  FixedTermNonEligible = "Fixed Term (Non-Eligible)",
  RegularEligible = "Regular (Eligible)",
  RegularNonEligible = "Regular (Non-Eligible)",
  Temporary = "Temporary",
}

export const EmployeeTypeDisplay: Record<EmployeeType, string> = {
  [EmployeeType.Contractor]: "Contractor",
  [EmployeeType.FixedTermEligible]: "Fixed Term (Eligible)",
  [EmployeeType.FixedTermNonEligible]: "Fixed Term (Non-Eligible)",
  [EmployeeType.RegularEligible]: "Regular (Eligible)",
  [EmployeeType.RegularNonEligible]: "Regular (Non-Eligible)",
  [EmployeeType.Temporary]: "Temporary",
};
